var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card card_product" }, [
    _c("div", { staticClass: "product_wrap" }, [
      _c(
        "a",
        {
          staticClass: "image_part lazy",
          attrs: { href: _vm.detailUrl, "aria-label": _vm.titleText },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onPdpClick.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: _vm.thumbnailUrl,
              "data-static": _vm.thumbnailStaticUrl,
              alt: _vm.titleWithBrand,
              onerror: "this.src=this.dataset.static",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content_part" }, [
        _c("div", { staticClass: "brand_sku" }, [
          _vm.brand
            ? _c("div", {
                staticClass: "product_brand",
                domProps: { innerHTML: _vm._s(_vm.brand) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isUsedEquipment
            ? _c("div", { staticClass: "product_sku" }, [
                _c("strong", [_vm._v("SKU: ")]),
                _vm._v(_vm._s(_vm.productSku)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.titleText
          ? _c("div", { staticClass: "product_title" }, [
              _c(
                "a",
                {
                  attrs: { href: _vm.detailUrl },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onPdpClick.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.titleText))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.bulletOne || _vm.bulletTwo || _vm.bulletThree
          ? _c("ul", { staticClass: "product_specs" }, [
              _vm.bulletOne
                ? _c("li", { domProps: { innerHTML: _vm._s(_vm.bulletOne) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.bulletTwo
                ? _c("li", { domProps: { innerHTML: _vm._s(_vm.bulletTwo) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.bulletThree
                ? _c("li", { domProps: { innerHTML: _vm._s(_vm.bulletThree) } })
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.primaryCta.isAddToCart && _vm.ctaUrl
          ? _c(
              "button",
              {
                staticClass: "styled_button yellow product_raq_button",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.requestAQuote.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Request a Quote")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "product_controls" },
              [
                _vm.primaryCta.isAddToCart &&
                _vm.addToCartOptions.labels != null
                  ? _c("add-to-cart", {
                      attrs: {
                        product: _vm.addProductData,
                        options: _vm.addToCartOptions,
                        "image-url": _vm.thumbnailUrl,
                        "button-disabled": _vm.addButtonDisabled,
                        "product-pricing": _vm.productPricing,
                      },
                      on: {
                        addedtocart: function ($event) {
                          return _vm.$emit("addedtocart")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "product_price",
            class: {
              is_used_equipment: _vm.isUsedEquipment,
              no_price_displayed: !_vm.productPriceShown,
              has_price_displayed: _vm.productPriceShown,
            },
          },
          [
            _vm.productPriceShown
              ? _c("pricing-info", {
                  attrs: {
                    "is-new-equipment": _vm.isNewEquipment,
                    loading: _vm.priceLoading,
                    show: _vm.showPrice,
                    "price-object": _vm.productPricing,
                    "show-old": !_vm.isNewEquipment,
                    "no-cents": !_vm.showCents,
                  },
                })
              : _vm.isUsedEquipment
              ? _c("pricing-info")
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "styled_button colourless product_view_details_button",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onPdpClick.apply(null, arguments)
              },
            },
          },
          [_vm._v("View Details")]
        ),
        _vm._v(" "),
        _vm.promoText
          ? _c("div", { staticClass: "price_help" }, [
              _vm._v(_vm._s(_vm.promoText)),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }